import React, { createContext, useState, useContext } from "react";
import { getOvertimeReports, getDayoffReports } from "../api/reportsApi";

const PendingReportsContext = createContext();

export function PendingReportsProvider({ children }) {
  const [pendingOvertimesCount, setPendingOvertimesCount] = useState(0);
  const [pendingDayoffsCount, setPendingDayoffsCount] = useState(0);

  const updatePendingCounts = async () => {
    try {
      const [overtimeReports, dayoffReports] = await Promise.all([
        getOvertimeReports(),
        getDayoffReports(),
      ]);

      const pendingOvertimes =
        overtimeReports?.overtimes?.filter(
          (report) =>
            !report.status ||
            Object.values(report.status).some(
              (status) =>
                status === "На рассмотрении" ||
                (typeof status === "object" &&
                  status.is_approved === "На рассмотрении")
            )
        ) || [];

      const pendingDayoffs =
        dayoffReports?.filter(
          (report) => !report.status || report.status === "На рассмотрении"
        ) || [];

      setPendingOvertimesCount(pendingOvertimes.length);
      setPendingDayoffsCount(pendingDayoffs.length);
    } catch (error) {
      console.debug("Нет отчетов на согласование");
      setPendingOvertimesCount(0);
      setPendingDayoffsCount(0);
    }
  };

  return (
    <PendingReportsContext.Provider
      value={{
        pendingOvertimesCount,
        pendingDayoffsCount,
        updatePendingCounts,
      }}
    >
      {children}
    </PendingReportsContext.Provider>
  );
}

export const usePendingReports = () => useContext(PendingReportsContext);
